// extracted by mini-css-extract-plugin
module.exports = {"input":"booleanInput__input___9r-jf"};